import React, { FC } from 'react'
import styled, { css } from 'styled-components'

import { buttonReset, getThemeColor, hoverDefault } from '../../utils/styles'
import mq from '../../utils/mq'
import { SectionTabsProps } from './section-tabs'

const StyledTabsHeader = styled.div<{ divider?: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  ${mq.mobile(css`
    overflow-x: auto;
    justify-content: flex-start;
    scroll-snap-type: x mandatory;
  `)};

  ${({ divider, ...props }) =>
    divider &&
    css`
      :after {
        background-color: ${getThemeColor('border')(props)};
        bottom: 0;
        content: '';
        height: 1px;
        position: absolute;
        width: 100vw;
      }
    `}
`

const StyledItem = styled.button<{
  underline?: boolean;
  extended?: boolean;
  active?: boolean;
}>`
  ${hoverDefault};
  ${buttonReset};
  display: flex;
  align-items: center;
  height: 80px;
  padding: 0 47px;
  font-weight: 700;
  font-size: 18px;
  cursor: pointer;
  z-index: 1;

  ${(props) => css`
    color: ${getThemeColor('silver')(props)};
  `}

  &:focus {
    outline: none;
  }

  ${(props) =>
    props.extended &&
    css`
      padding: 0 94px;
    `};

  ${(props) =>
    props.active &&
    css`
      background-color: #fff;
      color: ${getThemeColor('black')(props)};
      pointer-events: none;
    `};

  ${({ underline, active, ...props }) =>
    underline &&
    css`
      background-color: transparent;
      padding: 0;
      margin: 0 32px;
      border-bottom: 0.2rem transparent solid;

      :hover,
      :focus {
        color: ${getThemeColor('white')(props)};
        border-bottom-color: ${getThemeColor('vividPrimary')(props)};
      }

      ${active &&
      css`
        color: ${getThemeColor('white')(props)};
        border-bottom-color: ${getThemeColor('vividPrimary')(props)};
      `}
    `}

  ${mq.mobile(css`
    min-width: 40%;
    justify-content: center;
    font-size: 13px;
    padding: 0 18px;
    scroll-snap-align: start;
  `)};
`

interface TabsHeaderProps
  extends Pick<SectionTabsProps, 'theme' | 'items' | 'extended'> {
  activeIndex?: number;
  onSwitch: (index: number) => any;
}

const TabsHeader: FC<TabsHeaderProps> = ({
  theme,
  items,
  activeIndex,
  onSwitch,
  extended
}) => {
  return (
    <StyledTabsHeader divider={theme === 'dark'}>
      {items.map((item, index) => {
        return (
          <StyledItem
            key={index}
            active={activeIndex === index}
            onClick={() => onSwitch(index)}
            extended={extended}
            underline={theme === 'dark'}
          >
            {item.name}
          </StyledItem>
        )
      })}
    </StyledTabsHeader>
  )
}

export default TabsHeader
